var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3LightOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h4v10h-4V59zM17 36H7v4h10v-4zm9.66 4.36A11.85 11.85 0 0130 29.5c1.148-1.12 2.508-2 4-2.59V18h8v8.1l4-3.73V17a8 8 0 00-16 0v7.47A15.889 15.889 0 0022.42 38a15.62 15.62 0 001 5.4l3.24-3.04zM59 40h10v-4H59v4zm-7.64 14.28l7.07 7.07 2.83-2.83-7.07-7.07-2.83 2.83zM76 0v5.38L51.11 28.53A15.89 15.89 0 0128 50.06L0 76v-5.37l25.29-23.54 3-2.76 17.08-15.92 3-2.76L76 0zM50.25 38c0-2.398-.732-4.74-2.1-6.71l-17.22 16A11.9 11.9 0 0050.25 38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Light_off.881b4abf.svg";
export { SvgA3LightOff as ReactComponent };